export default {
  props: ['value','disabled'],
  data(){
    return {
      insuranceData:[],
      currentData:[]
    }
  },
  created() {
    this.$watch('value', function(nv) {
      this.query()
      if (nv && nv.length == 2) {
        this.currentData = nv
      }
    }, { immeidate: true , deep:true})

    this.query()
  },
  methods: {
    query() {
      this.$request.partnerSelect().then(resp => {
        // https://doc.zjtianyoukeji.com/LSP/%E8%BD%A6%E8%81%94%E7%BD%910615/#id=9niutl&p=%E8%BD%A6%E8%BE%86%E4%BF%A1%E6%81%AF_v_2_0_&g=1
        // 只取"天邮自用" 类型 保险公司和方案
        let companies = (resp.data || []).filter(i => i.cooperatorType == 0 || i.cooperatorType == 2).map(i => ({id : i.id , value:i.cooperatorName , label:i.cooperatorName}))
        let hash = this.$utils.map(companies , 'id')
        this.$request.insuranceSelect().then( resp => {
          let insuranceData = resp.data || []
          for(let i of insuranceData){
            let id = i.cooperatorId
            if(hash[id]){
              if( !hash[id].children ){
                hash[id].children = []
              }
              hash[id].children.push({value:i.id , label:i.insuranceName})
            }
          }
          this.insuranceData = Object.values(hash).filter(i => !!i.children)
        })
      })
    },
    handleChange(value , all){
      //[保险公司名,保险方案id]
      let publiucValue = [...value]
      console.log(publiucValue)
      this.$emit('input' , publiucValue)
      this.$emit('on-change' , publiucValue)
      this.$emit('change' , publiucValue)
    }
  },
  render() {
    return <Cascader disabled={this.disabled} data={ this.insuranceData } value={this.currentData} on-on-change={this.handleChange} ></Cascader>
  }
}
